<template>
  <div>
      <b-modal id="modalFiltro"  ref="modalFiltro" title="Filtrar visualização de notas" >
            <div  style=" display: flex;    justify-content: center;">
                <div class="filtros" >
                    <span style="margin-top: 25px;">Filtrar por <span class="corB">data de emissão:</span></span>
                        <div class="filtrosA">
                            <div >
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Data Início</label
                                >
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                    <span
                                        class="input-group-text"                            
                                        ><i class="fas fa-calendar"></i
                                    ></span>
                                    </div>
                                    <datepicker
                                    id="value2"                                   
                                    placeholder=""
                                    format="dd/MM/yyyy"
                                    :language="ptBR"
                                    :full-month-name="true"
                                    ></datepicker>
                                </div>
                            </div>
                            <div style="margin-left:10px;">
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Data Fim</label
                                >
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                    <span
                                        class="input-group-text"                               
                                        ><i class="fas fa-calendar"></i
                                    ></span>
                                    </div>
                                    <datepicker
                                    id="value1"                                  
                                    placeholder=""
                                    format="dd/MM/yyyy"
                                    :language="ptBR"
                                    :full-month-name="true"
                                    ></datepicker>
                                </div>
                            </div>
                            
                        </div>
                        <br v-if="$store.state.tipoNota == 'NFe'">
                        <span v-if="$store.state.tipoNota == 'NFe'">Filtrar <span class="corB">por valor: </span></span>
                        <div class="filtrosA valorF" v-if="$store.state.tipoNota == 'NFe'">
                            
                            <div>
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Minimo</label
                                ><br>
                                <input type="text" v-model="min" style="padding-left:10px;">
                            </div>
                            <div style="margin-left:10px;">
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Máximo</label
                                ><br>
                                <input type="text" v-model="max" style="padding-left:10px;">
                            </div>
                        </div>
                        <br>
                        <div class="filtrosA valorF" v-if="$store.state.tipoNota == 'NFe'" >                    
                            <div>
                                <label
                                    for="nome"
                                    style="margin-bottom:3px; "
                                    >Filtrar por <span class="corB">empresa emissora:</span></label
                                ><br>
                                <input type="text" style="width:322px; padding-left:10px;" v-model="emissora">
                            </div>                     
                        </div>  
                        <br>                     
                        <div class="filtrosA valorF" v-if="$store.state.tipoNota == 'NFe'">                            
                            <div>
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Filtrar <span class="corB">por NCM:</span></label
                                ><br>
                                <input type="text" v-model="ncm" style="padding-left:10px;">
                            </div>
                            <div style="margin-left:10px;">
                                <label
                                    for="nome"
                                    style="margin-bottom:3px;"
                                    >Filtrar <span class="corB">por CST ICMS:</span></label
                                ><br>
                                <input type="text" v-model="cst"  style="padding-left:10px;">
                            </div>
                        </div>

                        <label v-if="$store.state.tipoNota == 'NFe'"
                                    for="nome"
                                    style="margin-bottom:3px;margin-top:20px"
                                    >Filtrar <span class="corB">por estado emitente:</span></label
                                >
                        <select v-if="$store.state.tipoNota == 'NFe'" placeholder="UF" id="uf" type="text" style="width: 100%;
    height: 33px;

    border-radius: 5px;
    border: 1px solid #009188;">
            <option value="UF">UF</option>
            <option :value="e.codigo" v-for="(e, i) in estados" :key="i">
              {{ e.uf }}
            </option>
          </select >
                        <div class="opFiltro">
                            <p @click="voltar">Voltar</p>
                            <div @click="aplicarFiltro">Aplicar Filtro</div>
                        </div>
                </div>   
                        
            </div>
        </b-modal>
  </div>
</template>
<script>
import { en, es, ptBR } from "vuejs-datepicker/dist/locale";
import barramento from '../services/barramento'
import Datepicker from "vuejs-datepicker";
import cofing from '../services/config'
export default {   
     components: {  Datepicker},
    data(){
        return{
            emissora:'',
            cst:'',
            ncm:'',
            existeNota:true,
            en: en,
            es: es,
            ptBR: ptBR,            
            max:'',
            min:'',
            estados:[]
        }
    },
    methods:{ 
       voltar(){
            this.$refs['modalFiltro'].hide()
        }, 
        aplicarFiltro(){
            let estado = ''
            if(this.$store.state.tipoNota != 'CTe'){
                if(this.estados.filter(e=> e.codigo == document.getElementById("uf").value).length >0){
                    estado  = this.estados.filter(e=> e.codigo == document.getElementById("uf").value)[0].estado
                }
            }
           
            let dataInicio = document.querySelector('#value2').value
            let dataFim = document.querySelector('#value1').value
            console.log(dataInicio,dataFim)
            let objF = this.$store.state.tipoNota == 'NFe' ? {dataInicio,dataFim,"max":this.max,"min":this.min,"emissora":this.emissora,"cst":this.cst,"ncm":this.ncm,"estado":document.getElementById("uf").value} :{dataInicio,dataFim} 
            barramento.$emit('aplicarFiltro',objF,this.$store.state.tipoNota,true,estado)    
        }
    }, 
    mounted(){     
        this.max = ''
        this.min = ''
        this.cst = ''
        this.emissora = ''
        this.ncm = ''      
        this.$emit('thisDoModalFiltro',{"show":this.$refs["modalFiltro"].show,"hide":this.$refs["modalFiltro"].hide})
    },
    async created(){ 
         
      this.estados = await cofing.consultarEstado()
    
        barramento.$on('abrirModalFiltro',()=>{          
            this.$refs['modalFiltro'].show()
        })  
        document.documentElement.scrollTop = 0;
    }
}
</script>

<style>
.opFiltro{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:30px;
    margin-bottom: 20px;
}
.opFiltro p {
    margin-bottom: 0px;
    color: #9C9898;
    font-weight: bold;
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
}
.opFiltro div{
    background: #009188;
    font-weight: 600;
    color: #fff;
    padding: 7px;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
}
input:focus{
    outline: none !important;
}
.valorF input{
    height: 33px;
    border-radius: 5px;
    border: 1px solid #009188;
    width: 156px;
}
.abrirFiltro{
    width: 171px;       
    color: #fff;
    border-radius: 5px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    background: #009188;
    cursor: pointer;
    margin-top:40px;
}
 
.corB{
    font-weight: bold;
    margin-right: 10px;
}
.filtrosA{display: flex;}
.filtros{
    display: flex;       
    flex-direction: column;
}
#modalFiltro .modal-footer{
    display: none;
}
#modalFiltro___BV_modal_title_{
    color:#707070;
    font-weight: bold;
}
.vdp-datepicker input{
    width: 100px;
    height: 33px;
    margin-top: 1px;
    border-color: #009188;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    border: 1px solid #009188;
}
.input-group-prepend span.input-group-text{
    border-bottom-left-radius: 10px;
    height: 35px;
    border-top-left-radius: 10px;
    background: #009188;
    padding-left: 20px;
    padding-right: 20px;
}
.fa-calendar{
    color:#fff;
}
</style>